// extracted by mini-css-extract-plugin
export var active = "_4f-7";
export var container = "_4f-0";
export var evenWidth = "_4f-4";
export var large = "_4f-5";
export var outlet = "_4f-8";
export var slide = "_4f-2";
export var small = "_4f-6";
export var tab = "_4f-3";
export var tabs = "_4f-1";